import { useTheme } from './ThemeProvider';
import { useMemo } from 'react';
import { ThemeColors } from './types';

export const useThemeColors = () => {
  const { colors, theme } = useTheme();

  return useMemo(
    () => ({
      ...colors,
      // Helper functions
      getColor: (color: keyof ThemeColors) => colors[color],
      getCSSVariable: (variable: string) => {
        if (typeof window === 'undefined') return '';
        const computed = getComputedStyle(document.documentElement);
        return computed.getPropertyValue(`--${variable}`).trim();
      },
      // Semantic helpers
      isDark: theme === 'dark' || theme === 'business' || theme === 'grove-dark',
      isLight: theme === 'light' || theme === 'cupcake' || theme === 'grove-light',
    }),
    [colors, theme]
  );
};
